import React from 'react';
import styled from 'styled-components/macro';
import { useApiRequest } from '../../api/useApiRequest';
import { ManifoldsDiagram } from './manifold-diagram/ManifoldsDiagram';
import { GetRequest } from '../../shared/GetRequest';
import { MapPage } from './MapPage';
import { PdfDataResponse } from './PdfDataResponse';

type Props = { projectId: string; designId: string; unitId: number };

export const ManifoldsDiagramPdf = ({ projectId, designId, unitId }: Props) => {
  const getPdfDataRequest = useApiRequest<PdfDataResponse>({
    endpointUrl: `projects/${projectId}/designs/${designId}/units/${unitId}/pdf/data`,
    httpMethod: 'get',
  });

  return (
    <GetRequest getDataRequest={getPdfDataRequest}>
      {({ response: { unit, pdfDetail, unitPumps, heatSources, pipes, manifoldPumps } }) => {
        // This diagram is rendered in HTML so that it can be exported to PDF using the Print Dialogue and 'Save as PDF'
        // Option (i.e. Not 'Microsoft Print to PDF')
        // The current necessary settings are landscape A3 (which will always be true) and scaling to 68 (in advanced options)
        // This PDF forms the first half of a PDF which includes the design drawings, so it has to look as similar as possible
        // To the PDFs that they generate in AutoCAD for the room diagrams
        const totalNumberOfPages = 1 + unit.manifolds.length + pdfDetail.numberOfPagesNotIncluded;

        return (
          <PdfContainer>
            <MapPage
              unit={unit}
              manifoldPumps={manifoldPumps}
              unitPumps={unitPumps}
              heatSources={heatSources}
              pipes={pipes}
              totalNumberOfPages={totalNumberOfPages}
              pdfDetail={pdfDetail}
            />
            <ManifoldsDiagram
              manifolds={unit.manifolds}
              pdfDetail={pdfDetail}
              pagesBeforeDiagram={1}
              totalNumberOfPages={totalNumberOfPages}
            />
          </PdfContainer>
        );
      }}
    </GetRequest>
  );
};

const PdfContainer = styled.div`
  print-color-adjust: exact;
  -webkit-print-color-adjust: exact;
`;
